export const BG_COLORS = {
  BLUE: '#C6DEE7',
  LIGHT_BLUE: '#D9E9EF',
  GRAY: '#f2eeea',
}
